import { render, staticRenderFns } from "./channel-guide.vue?vue&type=template&id=40743c05&scoped=true&lang=pug"
import script from "./channel-guide.vue?vue&type=script&lang=js"
export * from "./channel-guide.vue?vue&type=script&lang=js"
import style0 from "./channel-guide.vue?vue&type=style&index=0&id=40743c05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40743c05",
  null
  
)

export default component.exports